import React from "react";
import StyledGrid from "./Grid.styled";

const Grid = StyledGrid;

export default Grid;
